import Constants from "expo-constants";
import * as Notifications from "expo-notifications";

export const registerForPushNotificationsAsync = async () => {
  try {
    const { status: existingStatus } = await Notifications.getPermissionsAsync();
    let finalStatus = existingStatus;
    // only ask if permissions have not already been determined, because
    // iOS won't necessarily prompt the user a second time.
    if (existingStatus !== "granted") {
      // Android remote notification permissions are granted during the app
      // install, so this will only ask on iOS
      const { status } = await Notifications.requestPermissionsAsync();
      finalStatus = status;
    }

    // Stop here if the user did not grant permissions
    if (finalStatus !== "granted") {
      alert(
        "Não foi possivel obter a permissão de Notificação, precisamos dela para informá-lo sobre o status do seu pedido."
      );
      return;
    }

    // Get the token that uniquely identifies this device
    const token = await Notifications.getExpoPushTokenAsync({
      projectId: Constants.expoConfig.extra.eas.projectId,
      experienceId: Constants.expoConfig.extra.eas.experienceId,
    });

    return token.data;
  } catch (error) {
    console.error(error);
  }
};
